import { render } from "./GestionePratiche.vue?vue&type=template&id=72337fd0&scoped=true"
import script from "./GestionePratiche.vue?vue&type=script&lang=js"
export * from "./GestionePratiche.vue?vue&type=script&lang=js"

import "./GestionePratiche.vue?vue&type=style&index=0&id=72337fd0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72337fd0"]])

export default __exports__